function padLeft(string, pad, length) {
  return (new Array(length + 1).join(pad) + string).slice(-length);
}

export function formatTimestamp(duration) {
  const minutes = Math.floor(duration / 60);
  const seconds = Math.floor(duration - minutes * 60);
  const prettySeconds = padLeft(seconds, "0", 2);

  return `${minutes}:${prettySeconds}`;
}
